import { useContext } from 'react';
import { MobxContext } from '~/index';

/**
 * Получает контекст Mobx хранилищ, который используется ТОЛЬКО внутри функицональных компонентов
 * @returns 
 */
export const useStore = () => useContext(MobxContext);